// hrpayroll/src/pages/Profile/Profile.tsx
import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import { getMyProfile } from "../../api/profile";
import ProfileTab from "./ProfileTab";
import SecurityTab from "./SecurityTab";
import NotificationsTab from "./NotificationsTab";

export type MyProfile = {
  id: string | null; has_employee_record?: boolean; user_id: string; employeeID: string | null;
  first_name: string; last_name: string; name: string; email: string; role: string;
  phone?: string; gender?: string; date_of_birth?: string | null;
  designation?: string; department_id?: string; hire_date?: string | null;
  profile_photo_url?: string | null; branchName?: string | null;
  current_address1?: string; current_address2?: string; current_city?: string;
  current_state?: string; current_pin?: string;
  permanent_address1?: string; permanent_address2?: string; permanent_city?: string;
  permanent_state?: string; permanent_pin?: string;
};

export default function Profile() {
  const [profile, setProfile] = useState<MyProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const data = await getMyProfile();
      setProfile(data);
    } catch {
      setProfile(null); // silent fallback — no error toast (project rule)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { reload(); }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <div className="mb-6">
        <h1 className="text-[22px] font-semibold text-[#1a1a1a] leading-tight tracking-[-0.01em]">
          My Profile
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          View your details, manage your password and notifications.
        </p>
      </div>

      <Tabs defaultValue="profile" className="w-full">
        <TabsList>
          <TabsTrigger value="profile">Profile</TabsTrigger>
          <TabsTrigger value="security">Security</TabsTrigger>
          <TabsTrigger value="notifications">Notifications</TabsTrigger>
        </TabsList>

        <TabsContent value="profile">
          {loading ? <p className="text-sm text-gray-400 py-8">Loading…</p>
            : profile ? <ProfileTab profile={profile} onSaved={reload} />
            : <p className="text-sm text-gray-400 py-8">No profile found.</p>}
        </TabsContent>
        <TabsContent value="security">
          <SecurityTab />
        </TabsContent>
        <TabsContent value="notifications">
          <NotificationsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
